<template>
  <div>
    <div>
      <div class="px-6 pt-8 text-left">
        <router-link
          v-for="(el, index) in $tm('navigation.dropdown')"
          v-bind:key="el.link"
          :to="{ name: el.active === 'false' ? 'dashboard' : el.link }"
        >
          <div
            v-if="index !== 0"
            class="relative cursor-pointer py-6 text-sm font-medium text-grey-3"
            :class="{
              'border-b': index < $tm('navigation.dropdown').length - 1,
            }"
          >
            <div class="flex">
              <img :src="getImageUrl(el.link)" alt="" />
              <div class="absolute left-8 top-1/2 -translate-y-1/2 transform">
                {{ el.name }}
              </div>
              <img
                src="@/assets/svg/chev-right-2.svg"
                alt=""
                class="absolute right-0 top-1/2 -translate-y-1/2 transform"
              />
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  setup() {
    function getImageUrl(name) {
      return require(`/src/assets/svg/navigation/${name}.svg`)
    }
    return {
      getImageUrl,
    }
  },
}
</script>
